import axios from 'axios';

import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  data = [];
  link = '';

  constructor(parent) {
    super(parent);
    this.link = window.location.href;
    window.addEventListener('hashchange', () => {
      this.link = window.location.href;
    });
  }

  get items() {
    return this.data.filter(i => this.link.includes(i.page));
  }

  get() {
    axios
      .get('/tourclient/api/Wiki/Get')
      .then(({ data = [] }) => {
        this.data = data
          .filter(i => i.IsOn)
          .map(i => ({
            id: i.ID,
            link: i.IconLink,
            page: i.PageLink,
            label: i.PageName,
            icon: i.Type === 'Article' ? 'mdi-wikipedia' : 'mdi-youtube',
          }));
      })
      .catch(() => {
      });
  }

  init() {
    this.get();
    return Promise.resolve();
  }
}
